export const ApiRoutes = {
  MEDIA_BASE_URL: process.env.REACT_APP_MEDIA_BASE_URL,
  API_HOSTNAME: process.env.REACT_APP_API_ENDPOINT,
  FACEBOOK_URL: process.env.REACT_APP_FACEBOOK_URL,
  WS_HOSTNAME: process.env.REACT_APP_WEB_SOCKET_URL,
  FACEBOOK_SDK_URL: process.env.REACT_APP_FACEBOOK_SDK,
  CRYPTO_JS_KEY: process.env.REACT_APP_CRYPTO_JS_KEY,

  LOGIN: "login",
  GET_STAFF: "getstaff",
  ATTRIBUTE: "attribute",
  CHECK_OTP: "check-otp",
  GET_MEDIA: "get-medias",
  GET_BALANCE: "get-balance",
  INSERT_STAFF: "insertstaff",
  UPDATE_STAFF: "updatestaff",
  GET_CUSTOMER: "getcustomer",
  GET_CHAT_LIST: "getchatlist/v2",
  DELETE_MEDIA: "delete-media",
  MEDIA_UPLOAD: "media-upload",
  CHECK_DEVICE: "check-device",
  REGISTRATION: "registration",
  SLIDER_LIST: "get-sliderlist",
  GET_LANGUAGES: "getlanguages",
  GET_TEMPLATES: "gettemplates",
  GET_TEMPLATES_COUNTERS: "gettemplatescounters",
  DELETE_SLIDER: "delete-slider",
  INSERT_SLIDER: "insert-slider",
  FAIL_CAMPAIGN: "fail-campaign",
  MESSAGES_FAIL: "fail-messages",
  DEVICE_LOGOUT: "device-logout",
  SEND_MESSAGE: "/v1/sendmessage",
  SYNC_TEMPLATES: "synctemplates",
  GET_BROADCAST: "getwabroadcast",
  RESETPASSWORD: "reset-password",
  GET_MEDIA_LIST: "get-media-list",
  RETRY_CAMPAIGN: "retry-campaign",
  CREATE_PACKAGE: "create-package",
  UPDATE_SETTING: "update-setting",
  UPDATE_PACKAGE: "update-package",
  MESSAGES_RETRY: "retry-messages",
  GET_USER_DEVICE: "get-userdevice",
  INSERT_CUSTOMER: "insertcustomer",
  UPDATE_CAMPAIGN: "updatecampaign",
  CHANGE_PASSWORD: "changepassword",
  CAMPAIGN_LIST: "get-campaignlist",
  UPDATE_CAMPAIGN_STATUS: "updatecampaignstatus",
  CAMPAIGN_NUMBER_LIST: "getcampaignnumberreportlist",
  CAMPAIGN_NUMBER_REPORT_COUNTER: "getcampaignnumberreportcounter",
  CAMPAIGN_REPORT_COUNTER: "getcampaignreportcounter",
  DELETE_CAMPAIGN: "deletecampaign",
  REAMING_CREDIT: "remainig-credit",
  GENERATE_API_KEY: "generateapikey",
  FORGOT_PASSWORD: "forgot-password",
  // GET_CHAT_BOT_FLOW: "getchatbotflow",
  GET_CHAT_BOT_FLOW: "getchatbot",
  GET_MESSAGE_LIST: "get-messagelist",
  GET_SETTING_DATA: "get-settingdata",
  GET_META_PACKAGE: "getwabapackages",
  RESEND_REGISTER_OTP: "register-otp",
  IMPORT_CUSTOMERS: "importcustomers",
  UPDATE_CUSTOMERS: "updatecustomers",
  INSERT_TEMPLATES: "inserttemplates",
  UPDATE_TEMPLATES: "updatetemplates",
  DELETE_TEMPLATES: "deletetemplates",
  DELETE_CUSTOMERS: "deletecustomers",
  GET_CUSTOMER_NOTE: "getcustomernote",
  GET_ALL_USER_LIST: "get-alluserlist",
  SEARCH_MESSAGE: "search-messagedata",
  CREATE_BROADCAST: "insertwabroadcast", // Insert broadcast
  GET_USER_DETAIL: "get-userdetailbyid",
  CREATE_CAMPAIGN: "/v1/createcampaign",
  GETGLOBALPACKAGES: "getglobalpackages",
  CHECK_USER_ACCOUNT: "checkuseraccount",
  GET_META_FEATURES: "getpackagefeature",
  SEARCH_CAMPAIGN: "search-campaigndata",
  DELETE_USER_DEVICE: "deleteuserdevice",
  UPDATE_STAFF_STATUS: "updatestaffstatus",
  GET_ATTRIBUTE_COLOR: "getattributecolor",
  UPDATE_META_PACKAGE: "updatewabapackage",
  INSERT_META_PACKAGE: "insertwabapackage",
  CHECK_REGISTER_OTP: "check-register-otp",
  UPDATE_USER_DEVICE: "updatedevicedetails",
  UPDATE_CHAT_BOT_FLOW: "updatechatbotflow",
  INSERT_CHAT_BOT_FLOW: "insertchatbotflow",
  DELETE_CHAT_BOT_FLOW: "deletechatbotflow",
  UPDATE_USER_PROFILE: "update-userprofile",
  PACKAGE_PURCHASE: "insertpackagepurchase",
  ADD_META_DETAILS: "insertuserwabadetails",
  GET_USER_WABA_DETAIL: "getuserwabadetail",
  GET_ALL_PACKAGE_LIST: "get-allpackagelist",
  INSERT_CUSTOMER_NOTE: "insertcustomernote",
  DELETE_CUSTOMER_NOTE: "deletecustomernote",
  UPDATE_CUSTOMER_NOTE: "updatecustomernote",
  LOW_CREDIT_USER_LIST: "low-credituserlist",
  GET_USER_PACKAGE_LIST: "getuserpackagelist",
  GET_USER_WABA_DETAILS: "getuserwabadetails",
  GET_DYNAMIC_VARIABLES: "getdynamicvariable",
  UPDATE_META_DETAILS: "updateuserwabadetail",
  GET_ADMIN_DEVICE_LIST: "get-admindevicelist",
  UPDATE_META_FEATURES: "updatepackagefeature",
  INSERT_META_FEATURES: "insertpackagefeature",
  GET_TEMPLATE_GATEGORY: "gettemplategategory",
  UPLOAD_TEMPLATE_MEDIA: "uploadtemplatemedia",
  DELETE_TEMPLATE_MEDIA: "deletetemplatemedia",
  GET_TEMPLATE_CATEGORY: "gettemplatecategory",
  CREATE_RAZORPAY_ORDER: "createrazorpayorder",
  REQUEST_TO_ADD_BALANCE: "requesttoaddbalance",
  CHANGE_PACKAGE_STATUS: "change-packagestatus",
  NEW_REGISTER_USER_LIST: "new-registeruserlist",
  INSERT_ATTRIBUTE_COLOR: "insertattributecolor",
  ADD_DYNAMIC_VARIABLES: "insertdynamicvariable",
  DELETE_ATTRIBUTE_COLOR: "deleteattributecolor",
  GET_PURCHASED_PACKAGES: "getpurchasedpackages",
  GET_CAROUSEL_TEMPLATES: "getcarouseltemplates",
  USER_DASHBOARD_COUNTER: "user-dashboardcounter",
  GET_MESSAGE_REPORT_BY_ID: "get-messagereportbyid",
  UPDATE_USER_WABA_DETAILS: "updateuserwabadetails",
  DELETE_DYNAMIC_VARIABLES: "deletedynamicvariable",
  SUPER_ADMIN_SEND_MESSAGE: "tls_admin/sendmessage",
  UPDATE_DYNAMIC_VARIABLES: "updatedynamicvariable",
  APPROVAL_CREDIT_REQUEST: "approval-creditrequest",
  ADMIN_DASHBOARD_COUNTER: "admin-dashboardcounter",
  INSERT_TEMPLATE_CATEGORY: "inserttemplatecategory",
  ADD_QUICK_REPLY_MESSAGE: "insertquickreplymessage",
  UPDATE_TEMPLATE_CATEGORY: "updatetemplatecategory",
  DELETE_TEMPLATE_CATEGORY: "deletetemplatecategory",
  DOWNLOAD_BILLING_INVOICE: "downloadbillinginvoice",
  GET_CAMPAIGN_REPORT_BY_ID: "get-campaignreportbyid",
  PACKAGE_PURCHASE_HISTORY: "packagepurchase-history",
  MOBILE_NUMBER_LIST: "getuserallconnecteddevicelist",
  GET_QUICK_REPLY_MESSAGE_LIST: "getquickreplymessage",
  DATE_WISE_MESSAGE_COUNTER: "message-datewisecounter",
  GET_ALL_PACKAGE_LIST_ADMIN: "get-allpackagelistadmin",
  UPDATE_QUICK_REPLY_MESSAGE: "updatequickreplymessage",
  DELETE_QUICK_REPLY_MESSAGE: "deletequickreplymessage",
  GET_USER_WABA_PHONE_NUMBERS: "getuserwabaphonenumbers",
  UPDATE_CHAT_BOT_FLOW_STATUS: "updatechatbotflowstatus",
  UPDATECHATBOTFLOWSTATUSV2: "updatechatbotflowstatusV2",
  GET_TAG_WISE_CUSTOMER_REPORT: "gettagwisecustomercount",
  SYNC_USER_WABA_PHONE_NUMBERS: "syncuserwabaphonenumbers",
  GET_TEMPLATE_COUNT_BY_WABA_ID: "gettemplatecountbywabaid",
  META_DASHBOARD_CHAT_COUNTER_API: "metadashboardchatcounter",
  PACKAGEPURCHASEFROMSUPERADMIN: "packagepurchasefromsuperadmin",
  GET_SEND_RECEIVE_MESSAGE_REPORT: "getsendreceivedmessagereport",
  GET_PACKAGE_PURCHASE_REQUEST_LIST: "get-packagepurchase-reqlist",
  UPDATE_TEMPLATE_CATEGORY_DETAIL: "updatetemplatecategorydetail",
  REGISTER_USER_WABA_PHONE_NUMBERS: "registeruserwabaphonenumbers",
  GET_ALL_PURCHASE_ADMIN_PACKAGE_LIST: "Tls_admin/get-allpackagelist",
  META_DASHBOARD_DEVICE_COUNTER_API: "metadashboarddevicewisecounter",
  INSERT_WABA_USER_BUSINESS: "insertwabauserbusiness",
  GET_USER_BUSINESS_CATALOG_LIST: "getuserbusinesscataloglist",
  GET_USER_BUSINESS_LIST: "getuserbusinesslist",
  CONNECT_CATALOGUE_WITH_WABA: "connectcatalogwithwaba",
  GET_CATALOGUE_PRODUCT_LIST: "getcatalogproductlist",
  META_DASHBOARD_FREE_CONVERSATION_REPORT:
    "getfreeserviceconversationanalyticsreport",
  // Flow
  INSERT_FLOW: "insertflowform",
  GET_FLOW_LIST: "getflowform",
  UPDATE_FLOW_FORM_META_DATA: "updateflowformmetadata",
  UPDATE_FLOW_FORM_JSON_DATA: "updateflowformjsondata",
  DELETE_FLOW: "deleteflowform",
  SYNC_FLOW_FORM: "syncflowform",
  PUBLISH_FLOW_FORM: "publishflowform",
  DEPRECATE_FLOW_FORM: "deprecateflowform",
  GET_SINGLE_WABA_DETAIL: "getsinglewabadetail",
  SYNC_CATALOGUE_LIST: "synccataloglist",
  SYNC_CONNECTED_CATALOG_PRODUCT_LIST: "syncconnectedcatalogproductlist",
  // Broadcast Report
  GET_BROADCAST_REPORT_BY_ID: "getwabroadcastreportbyid",
  // Storage
  GET_USER_USED_STORAGE: "getuserusedstorage",
  GETINVOICELIST: "getinvoicelist",

  //Contact Page api
  GETCUSTOMER: "getnonmetacustomer",
  INSERTCUSTOMER: "insertnonmetacustomer",
  DELETECUSTOMER: "deletenonmetacustomer",
  UPDATECUSTOMER: "updatenonmetacustomer",
  NONMETAPACKAGEPURCHASE: "nonmetapackagepurchase",
  IMPORTNONMETACUSTOMERDATA: "importnonmetacustomerdata",
  GETALLCAMPAIGN: "getallcampaign",
  NONMETAPACKAGEPURCHASE: "nonmetapackagepurchase",
  UPDATECRMLEADSETTING: "updatecrmleadsetting",
  GETALLCAMPAIGN: "getallcampaign",
  GETNONMETACHATLIST: "getnonmetachatlist",
  GETCUSTOMERBYCAMPAIGN: "getcustomerbycampaign",
  INSERTFILTER: "insertfilter",
  DELETEFILTER: "deletefilter",
  SETDEFAULTFILTER: "setdefaultfilter",
  GETFILTER: "getfilter",
  ASSIGNNONMETAAGENT: "assignnonmetaagent",
  GETMESSAGELISTFROMHISTORY: "get-messagelist-from-history",
  GETNONMETACUSTOMERDETAILBYID: "getnonmetacustomerdetailsbyid",
  GETCAMPAINGDETAILSBYID: "getcampaingdetailsbyid",
  GETCHATBOTFLOWDETAILS: "getchatbotflowdetails",
  LINKTO365CRM: "linkto365crm",
  UNLINK365CRM: "unlink365crm",
  GETCRMLEADEDITABLEFIELDS: "getcrmleadeditablefields",
  GETLEADPERMISSIONSTAFF: "getleadpermissionstaff",
  INSERTCHATBOTV2: "insertchatbotv2",
  GETCRMSETTING: "getcrmsetting",
  GETATTRIBUTES: "getattributes",
  UPDATECHATBOTV2: "updatechatbotv2",
  DELETECHATBOTV2: "deletechatbotv2",
  GETWPLEADEDITABLEFIELDS: "getwpleadeditablefields",
  CHECKCHATBOTLIMIT: "checkchatbotlimit",
};
